// @flow

import _ from 'lodash';

import ApiObject from './ApiObject';

import News from './News';

export default class NewsList extends ApiObject {

  list: Array<News> = [];

  postJsonAssignation(data: Object) {
    super.postJsonAssignation(data);

    this.list = [];
    _.each(data.list, (newsData: Object) => {
      const news: News = new News();
      news.fromJson(newsData);

      this.list.push(news);
    });
  }

  updateNews(newsToUpdate: News) {
    const tmp = [];

    _.each(this.list, (news: News) => {
      if (news.id !== newsToUpdate.id) {
        tmp.push(news);
      } else {
        tmp.push(newsToUpdate);
      }
    });

    this.list = tmp;
  }

  deleteNews(newsToDelete: News) {
    const tmp = [];

    _.each(this.list, (news: News) => {
      if (news.id !== newsToDelete.id) {
        tmp.push(news);
      }
    });

    this.list = tmp;
  }
}
